<script setup lang="ts">
import AppFooter from "./components/AppFooter.vue";
import AppHeader from "./components/AppHeader.vue";
import BackgroundShapes from "./components/BackgroundShapes.vue";
import ConfirmDialog from "./components/ConfirmDialog.vue";
</script>

<template>
  <div class="relative text-app-text antialiased">
    <BackgroundShapes />

    <div class="flex min-h-screen flex-col">
      <AppHeader />
      <main class="flex flex-1 flex-col">
        <router-view />
      </main>
    </div>

    <AppFooter />
    <ConfirmDialog />
  </div>
</template>
